const productToastMsg = {
  /**
   *  [상품 전체 리스트] 상품 전체 리스트 요청하기
   */
  GET_PRODUCT_ALL_LIST_REQUEST_SUCCESS: '상품 전체 리스트 요청하기 성공',
  GET_PRODUCT_ALL_LIST_REQUEST_ERROR: '상품 전체 리스트 요청하기 실패',

  /**
   *  [상품 승인 리스트] 상품 승인 리스트 요청하기
   */
  GET_PRODUCT_APPROVAL_LIST_REQUEST_SUCCESS: '상품 승인 리스트 요청하기 성공',
  GET_PRODUCT_APPROVAL_LIST_REQUEST_ERROR: '상품 승인 리스트 요청하기 실패',

  /**
   *  [상품 승인 리스트] 상품 승인 리스트 excel 다운로드
   */
  GET_PRODUCT_APPROVAL_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 승인 리스트 엑셀 다운로드 요청하기 성공',
  GET_PRODUCT_APPROVAL_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 승인 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [상품 금지 리스트] 상품 금지 리스트 요청하기
   */
  GET_PRODUCT_BAN_LIST_REQUEST_SUCCESS: '상품 금지 리스트 요청하기 성공',
  GET_PRODUCT_BAN_LIST_REQUEST_ERROR: '상품 금지 리스트 요청하기 실패',

  /**
   *  [상품 금지 리스트] 상품 금지 리스트 excel 다운로드
   */
  GET_PRODUCT_BAN_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 금지 리스트 엑셀 다운로드 요청하기 성공',
  GET_PRODUCT_BAN_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 금지 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [상품 속성 검수 리스트] 상품 속성 검수 리스트 요청하기
   */
  GET_PRODUCT_PROPERTY_REQUEST_LIST_REQUEST_SUCCESS: '상품 속성 검수 리스트 요청하기 성공',
  GET_PRODUCT_PROPERTY_REQUEST_LIST_REQUEST_ERROR: '상품 속성 검수 리스트 요청하기 실패',

  /**
   *  [상품 속성 검수 리스트] 상품 속성 검수 excel 리스트 다운로드 하기
   */
  GET_PRODUCT_PROPERTY_REQUEST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 속성 검수 리스트 엑셀 다운로드 요청하기 성공',
  GET_PRODUCT_PROPERTY_REQUEST_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 속성 검수 리스트 엑셀 다운로드 요청하기 실패',

  /**
   *  [상품 리스트] 태그 리스트 가져오기
   */
  GET_PRODUCT_TAG_COLUMN_TAG_LIST_REQUEST_ERROR: '상품 태그 리스트 요청하기 실패',

  /**
   *  [상품 상세] 상품 상세 요청하기
   */
  GET_PRODUCT_INFO_REQUEST_SUCCESS: '상품 상세 요청하기 성공',
  GET_PRODUCT_INFO_REQUEST_ERROR: '상품 상세 요청하기 실패',

  /**
   *  [상품 복사] 상품 상세 요청하기
   */
  GET_PRODUCT_COPY_INFO_REQUEST_SUCCESS: '상품 상세 요청하기 성공',
  GET_PRODUCT_COPY_INFO_REQUEST_ERROR: '상품 상세 요청하기 실패',

  /**
   *  [상품 상세] 상품 거절 사유 리스트 요청하기
   */
  GET_REJECT_REASON_LIST_REQUEST_SUCCESS: '상품 거절 사유 리스트 요청하기 성공',
  GET_REJECT_REASON_LIST_REQUEST_ERROR: '상품 거절 사유 리스트 요청하기 실패',

  /**
   *  [상품 등록] 상품 등록하기 전 필요한 데이터 가져오기
   */
  PREPARE_INSERT_PRODUCT_REQUEST_SUCCESS: '상품 등록하기 전 필요한 데이터 가져오기 성공',
  PREPARE_INSERT_PRODUCT_REQUEST_ERROR: '상품 등록하기 전 필요한 데이터 가져오기 실패',

  /**
   *  [상품 등록] 상점에 따라서 해당 상점의 A/S 정보와 배송정보 가져오기
   */
  GET_STORE_AS_AND_DELIVERY_INFO_REQUEST_SUCCESS: '상점에 따라서 해당 상점의 A/S 정보와 배송정보 가져오기 성공',
  GET_STORE_AS_AND_DELIVERY_INFO_REQUEST_ERROR: '상점에 따라서 해당 상점의 A/S 정보와 배송정보 가져오기 실패',

  /**
   *  [상품 등록] 상품 등록 요청하기
   */
  INSERT_PRODUCT_REQUEST_SUCCESS: '상품 등록 요청하기 성공',
  INSERT_PRODUCT_REQUEST_ERROR: '상품 등록 요청하기 실패',

  /**
   *  [상품 편집] 상품 편집 요청하기
   */
  EDIT_PRODUCT_REQUEST_SUCCESS: '상품 편집 요청하기 성공',
  EDIT_PRODUCT_REQUEST_ERROR: '상품 편집 요청하기 실패',

  /**
   *  [상품 삭제] 상품 삭제 요청하기
   */
  DELETE_PRODUCT_REQUEST_SUCCESS: '상품 삭제 요청하기 성공',
  DELETE_PRODUCT_REQUEST_ERROR: '상품 삭제 요청하기 실패',

  /**
   *  [상품 등록 승인] 상품 승인 요청하기
   */
  PERMIT_REGISTRATION_PRODUCT_REQUEST_SUCCESS: '상품 등록 승인 요청하기 성공',
  PERMIT_REGISTRATION_PRODUCT_REQUEST_ERROR: '상품 등록 승인 요청하기 실패',

  /**
   *  [상품 등록 거절] 상품 등록 거절 요청하기
   */
  REJECT_REGISTRATION_PRODUCT_REQUEST_SUCCESS: '상품 등록 거절 요청하기 성공',
  REJECT_REGISTRATION_PRODUCT_REQUEST_ERROR: '상품 등록 거절 요청하기 실패',

  /**
   *  [상품 판매 금지 승인] 상품 판매 금지 승인 요청하기
   */
  PERMIT_BAN_PRODUCT_REQUEST_SUCCESS: '상품 판매 금지 승인 요청하기 성공',
  PERMIT_BAN_PRODUCT_REQUEST_ERROR: '상품 판매 금지 승인 요청하기 실패',

  /**
   *  [상품 판매 금지] 상품 판매 금지 요청하기
   */
  REJECT_BAN_PRODUCT_REQUEST_SUCCESS: '상품 판매 금지 요청하기 성공',
  REJECT_BAN_PRODUCT_REQUEST_ERROR: '상품 판매 금지 요청하기 실패',

  /**
   *  [상품 버전] 상품 버전 정보 요청하기
   */
  GET_PRODUCT_VERSION_INFO_REQUEST_SUCCESS: '상품 버전 정보 요청하기 성공',
  GET_PRODUCT_VERSION_INFO_REQUEST_ERROR: '상품 버전 정보 요청하기 실패',

  /**
   *  [상품 버전] 상품 버전 상세 요청하기
   */
  GET_PRODUCT_VERSION_DETAIL_REQUEST_SUCCESS: '상품 버전 상세 요청하기 성공',
  GET_PRODUCT_VERSION_DETAIL_REQUEST_ERROR: '상품 버전 상세 요청하기 실패',

  /**
   *  [상품 상세] 사방넷으로 상품 정보 전송
   */
  SEND_PRODUCT_DATA_TO_SABANGNET_REQUEST_SUCCESS: '사방넷으로 정보 재 전송 송신 성공',
  SEND_PRODUCT_DATA_TO_SABANGNET_REQUEST_ERROR: '사방넷으로 정보 재 전송 송신 실패',

  /**
   *  엑셀 일괄 상품 할인 변경하기
   */
  EXCEL_BULK_EDIT_PRODUCT_DISCOUNT_REQUEST_SUCCESS: '엑셀 일괄 상품 할인 변경하기 성공',
  EXCEL_BULK_EDIT_PRODUCT_DISCOUNT_REQUEST_ERROR: '엑셀 일괄 상품 할인 변경하기 실패',

  /**
   *  상품 전체 리스트 엑셀 다운로드하기
   */
  GET_PRODUCT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS: '상품 전체 리스트 엑셀 다운로드 성공',
  GET_PRODUCT_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR: '상품 전체 리스트 엑셀 다운로드 실패',

  /**
   *  상품 일괄 편집 유효성 체크하기
   */
  GET_BULK_EDIT_PRODUCT_VALIDATE_RESULT_LIST_REQUEST_ERROR: '상품 일괄 편집 검사 실패',

  /**
   *  상품 일괄 편집
   */
  BULK_EDIT_PRODUCT_REQUEST_SUCCESS: '상품 일괄 편집 성공',
  BULK_EDIT_PRODUCT_REQUEST_ERROR: '상품 일괄 편집 실패',

  /**
   *  상품 태그 승인하기
   */
  PERMIT_REGISTRATION_PRODUCT_TAG_REQUEST_SUCCESS: '상품 태그 승인하기 성공',
  PERMIT_REGISTRATION_PRODUCT_TAG_REQUEST_ERROR: '상품 태그 승인하기 실패',

  /**
   *  상품 태그 거절하기
   */
  REJECT_REGISTRATION_PRODUCT_TAG_REQUEST_SUCCESS: '상품 태그 거절하기 성공',
  REJECT_REGISTRATION_PRODUCT_TAG_REQUEST_ERROR: '상품 태그 거절하기 실패',

  /**
   *  상품 속성 승인하기
   */
  PERMIT_REGISTRATION_PRODUCT_PROPERTY_REQUEST_SUCCESS: '상품 속성 승인하기 성공',
  PERMIT_REGISTRATION_PRODUCT_PROPERTY_REQUEST_ERROR: '상품 속성 승인하기 실패',

  /**
   *  상품 속성 거절하기
   */
  REJECT_REGISTRATION_PRODUCT_PROPERTY_REQUEST_SUCCESS: '상품 속성 거절하기 성공',
  REJECT_REGISTRATION_PRODUCT_PROPERTY_REQUEST_ERROR: '상품 속성 거절하기 실패',
};

export default productToastMsg;
